export default class {
  constructor({
    className,
    vimId,
  }) {
    // Elements and class variables
    const el = document.querySelector(className);
    const placeholder = el.querySelector(className + '__placeholder');
    const playButton = placeholder.querySelector('.btn');
    const spinner = el.querySelector('.video-body__spinner');

    // set iFrame attributes
    let iFrame = document.createElement('iframe');
    const attributes = {
      'width': '100%',
      'height': '800',
      'frameBorder': '0',
      'allowFullScreen': '',
      'mozallowfullscreen': '',
      'webkitAllowFullScreen': '',
      'src': 'https://player.vimeo.com/video/' + vimId + '?autoplay=true',
    }
    setAttrs(iFrame, attributes);

    let xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;

      if (xhr.status == 200) {
        spinner.classList.add('active');
        placeholder.style.display = 'none';
        el.insertBefore(iFrame, el.firstChild);
      }
    }

    xhr.open('GET', '#');

    playButton.addEventListener('click', function() {
      xhr.send();
      setTimeout(function() {
        spinner.classList.remove('active');
      }, 1000);
    });

    function setAttrs(el, attrs) {
      for(let key in attrs) {
        el.setAttribute(key, attrs[key]);
      }
    }
  }
}